import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../Actions/userLoginAction";
import { useEffect, useRef, useState } from "react";
import {
  LIST_UNIVERSITIES,
  LIST_UNIVERSITIES_RESET,
} from "../Actions/universityAction";
import { COUNTRIES_LIST } from "../Actions/countryAction";
import { listPartner } from "../Actions/partnerAction";
import { listUsers } from "../Actions/userAction";

export default function Header({ handleHide, Page }) {
  const [dropDown, setDropDown] = useState(false);
  const [Alert, setAlert] = useState(false);
  const [loginExpiry, setLoginExpiry] = useState(false);
  const { university_list_Error } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );
  const { userDet } = useSelector((state) => state.LoginReducer);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const loginRef = useRef();

  /* Logout Handle start */
  const handleLogout = (e) => {
    e.preventDefault();
    setAlert(false);
    setLoginExpiry(true);
    dispatch(LIST_UNIVERSITIES_RESET());
    dispatch(Logout());
    Navigate("/login");
  };
  /* Logout Handle End */

  /* Logout dropdown Menu */
  const handleDropDown = (e) => {
    e.preventDefault();
    setDropDown(!dropDown);
  };

  useEffect(() => {
    const handle = (e) => {
      if (!loginRef.current?.contains(e.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handle);
  }, []);

  useEffect(() => {
    dispatch(COUNTRIES_LIST());
    dispatch(LIST_UNIVERSITIES());
    dispatch(listPartner());
    dispatch(listUsers());
  }, [dispatch]);

  useEffect(() => {
    if (
      !loginExpiry &&
      university_list_Error &&
      university_list_Error?.includes("401")
    ) {
      setAlert(`${university_list_Error} Login Expired. Please `);
    }
  }, [university_list_Error]);

  return (
    <>
      <nav className="navbar">
        <div className="dekstop-view">
          {Alert && (
            <div className="side_drawer">
              <div className={"Alert3"}>
                <span onClick={() => setAlert(false)} className="close">
                  &times;
                </span>
                <p>
                  {Alert}
                  <span onClick={handleLogout} className="login_expiry">
                    Login
                  </span>{" "}
                  again or Contact Service Desk.
                </p>
              </div>
            </div>
          )}
          <div className="top-bar">
            <div className="user float-right dropdown">
              <ul className="nav navbar-nav ml-auto">
                <li className="nav-item">
                  <Link to="/">
                    <i className="fas fa-home"></i>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/setting" className="nav-link">
                    <i className="fa fa-cog"></i>
                  </Link>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>
                <li className="nav-item dropdown" ref={loginRef}>
                  <a
                    href="#"
                    className="nav-link dropdown-toggle"
                    onClick={handleDropDown}
                    data-toggle="dropdown"
                  >
                    {userDet ? userDet[0]?.first_name : ""}
                    <img
                      src="./assets/img/user.png"
                      className="dropdown-toggle rounded-circle"
                      alt="user"
                    />
                  </a>
                  <div
                    className={
                      dropDown
                        ? "dropdown-menu dropdown-menu-right dropdown-menu2"
                        : "dropdown-menu dropdown-menu-right"
                    }
                  >
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-user-circle" aria-hidden="true"></i>{" "}
                      Account
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-key" aria-hidden="true"></i> Change
                      Password
                    </a>
                    <div className="dropdown-divider"></div>
                    <a
                      href="#"
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      <i className="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </li>
              </ul>
            </div>

            <div className="top-left-bar float-left">
              <button
                className="openNav ml-5"
                type="button"
                data-toggle="canvas"
                data-target="#bs-canvas-left"
                onClick={handleHide}
                aria-expanded="false"
                aria-controls="bs-canvas-left"
              >
                &#9776;
              </button>
              <h1>{Page}</h1>
            </div>
          </div>
        </div>
        <></>
        <div className="mobile-view">
          <div className="top-bar">
            <div className="user float-right dropdown">
              <ul className="nav navbar-nav ml-auto">
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>

                <li className="nav-item show-user-view">
                  <a href="#" className="nav-link">
                    <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="brand-se">
              <Link to="/">
                <img
                  src="./assets/img/logo-icon.png"
                  className="img-icon"
                  alt="Search Education"
                />
              </Link>
            </div>
            <div className="top-left-bar float-left">
              <button
                className=" openNav ml-5"
                type="button"
                data-toggle="canvas"
                data-target="#bs-canvas-left"
                aria-expanded="false"
                aria-controls="bs-canvas-left"
              >
                &#9776;
              </button>
            </div>
          </div>

          <div className="user-mob-view user">
            <div className="user-mob-view-left">
              <ul className="nav navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    href="dashboard"
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    {userDet[0].first_name}{" "}
                    <img
                      src="./assets/img/user.png"
                      className="dropdown-toggle rounded-circle"
                      alt="user"
                    />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-user-circle" aria-hidden="true"></i>
                      Account
                    </a>
                    <a href="#" className="dropdown-item">
                      <i className="fa fa-key" aria-hidden="true"></i> Change
                      Password
                    </a>
                    <div className="dropdown-divider"></div>
                    <a
                      href="#"
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      <i className="fas fa-sign-out-alt"></i> Logout
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="user-mob-view-right">
              <ul className="nav navbar-nav">
                <li className="nav-item">
                  <Link to="/" className="nav-link">
                    <i className="fas fa-home"></i>
                  </Link>
                </li>
                <li className="nav-item">
                  <a href="settings" className="nav-link">
                    <i className="fa fa-cog"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link">
                    <i className="fas fa-search"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
